<template>
  <div>
    <div class="back-to-home rounded d-none d-sm-block">
      <a href="index.html" class="btn btn-icon btn-soft-primary"
        ><font-awesome-icon icon="home"
      /></a>
    </div>
    <section class="bg-home d-flex align-items-center">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-lg-6 col-md-5">
            <div class="mr-lg-5">
              <h3>
                <span class="text-success">Hvala!</span><br />Vprašalnik je
                zaključen.
              </h3>
              <img
                src="@/assets/images/illustrator/Asset189.svg"
                class="img-fluid d-block mx-auto"
                alt=""
              />
            </div>
          </div>
          <div class="col-lg-6 col-md-7">
            <div class="card login_page  border-0">
              <div class="card-body">
                <h4>Bi želeli še sodelovati?</h4>
                <b-btn size="lg" @click="resetQuiz()"
                  >Naloži dodatna vprašanja</b-btn
                >
              </div>
            </div>
          </div>
          <!--end col-->
        </div>
        <!--end row-->
      </div>
      <!--end container-->
    </section>
    <!--end section-->
  </div>
</template>
<script>
import { mapState } from "vuex";
import moment from "moment";
moment.locale("en");
export default {
  components: {},
  data() {
    return {
      projectSlug: this.$route.params.projectSlug,
    };
  },
  computed: {
    ...mapState({
      respondentId: (state) => state.api.respondentId,
      project: (state) => state.api.currentProject,
      projectSequences: (state) => state.api.projectSequences,
      currentSequenceOrder: (state) => state.api.currentSequenceOrder,
    }),
  },

  created() {},
  mounted() {},
  methods: {
    resetQuiz: function() {
      if (this.project.sequences) {
        if (
          this.project.custom_order &&
          this.currentSequenceOrder === this.projectSequences + 1
        ) {
          this.$store.commit("api/quizResetProgress");
          this.$store.commit("api/quizResetSequence");
        } else {
          this.$store.commit("api/quizResetProgress");
          this.$store.commit("api/resetMatchupOrder");
          this.$store.dispatch(
            "api/fetchRandomSequencesMatchups",
            this.project.random_slug
          );
        }
      } else {
        this.$store.commit("api/quizResetProgress");
      }

      this.$router.push({
        name: "Matchup",
        params: { projectSlug: this.projectSlug },
      });
    },
  },
};
</script>
